import styled from 'styled-components';

// Use this component when we need to add some styles on top of the PrismButton that isn't built-in already.
// In this case we need some shadow behind the button when it is white (secondary type)
export const PrismButtonWrapper = styled.div`
  & button[kind='BUTTON/SECONDARY'] {
    box-shadow: 0px 2px 8px 0px #00000033;
  }
`;

// Only for TagType.PositiveDefault
export const PrismTagWrapperPositiveDefault = styled.div`
  & > * {
    // Convert existing --color-info__light into rgb with opacity of 10%
    // This convertion works for all 3 types of colors that this can be (hex, rgb, and hsl)
    background: rgb(from var(--color-info__light) r g b / 10%);

    // Change text color
    div > * {
      color: var(--color-info__light);
    }

    // Change icon color
    svg > * {
      fill: var(--color-info__light);
    }
  }

  div {
    box-shadow: none;
    height: 100%;
  }

  // Force text inside tag to line break (For very rare case when user has super small viewport < 350px)
  span {
    text-wrap: wrap;
    line-break: word;
  }
`;

// Only for TagType.HighlightEmphasis
export const PrismTagWrapperHighlightEmphasis = styled.div`
  div {
    background-color: var(--color-info__light);
    box-shadow: none;
    height: 100%;
  }

  // Force text inside tag to line break (For very rare case when user has super small viewport < 350px)
  span {
    text-wrap: wrap;
    line-break: word;
  }
`;
